import React from 'react';

const AnimationConfigContext = React.createContext();
export default AnimationConfigContext;
